// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Email_Emails($patient_id: numeric!) {
  patient_contact_method_associations(
    args: { _patient_id: $patient_id, _type: "email" }
  ) {
    id
    person_id
    preference
    contact_method_id
    description
    email {
      id
      address
    }
    communication_preferences(where: { patient_id: { _eq: $patient_id } }) {
      id
      type
      patient_id
    }
  }
}

`